import {
  CreateCustomerReportRequest,
  CreateBillingReportRequest,
  CreateOrderReportRequest,
  CreateProductReportRequest,
  ReportResponse
} from "../../Models/Report";
import api from "../axios";

export const reportService = {
  createProductReport: async (data: CreateProductReportRequest): Promise<ReportResponse> => {
    const response = await api.post("/reports/products", data);
    return response.data;
  },

  createCustomerReport: async (data: CreateCustomerReportRequest): Promise<ReportResponse> => {
    const response = await api.post("/reports/customers", data);
    return response.data;
  },

  createBillingReport: async (data: CreateBillingReportRequest): Promise<ReportResponse> => {
    const response = await api.post("/reports/billing", data);
    return response.data;
  },

  createOrderReport: async (orderId: string, data?: CreateOrderReportRequest): Promise<ReportResponse> => {
    const response = await api.post(`/reports/orders/${orderId}`, data ?? {});
    return response.data;
  }
};
